module.exports = __webpack_public_path__ + "static/img/BY.171c335c.svg";